import { getLocalAPIBase } from "./getLocalAPIBase";

const apiHost = process.env.API_HOST;
const reviewApiHostRegex = /^\d+\.review\.whoosh\.io$/;
const demoApiHost = "api.demo.whoosh.io";
const reviewApiAvailabilityPath = "/.well-known/openid-configuration";
const reviewApiAvailabilityTimeoutMs = 1500;

let nativeReviewAPIHostPromise: Promise<string> | null = null;

export const resetNativeApiHostCacheForTests = () => {
  nativeReviewAPIHostPromise = null;
};

export const getNativeApiHost = async ({
  isLocal,
  configAPIBase,
}: {
  isLocal?: boolean;
  configAPIBase?: string;
}) => {
  if (isLocal) {
    return getLocalAPIBase();
  }

  const testConfigBase = !!apiHost ? apiHost : configAPIBase;

  return getAvailableNativeApiHost(testConfigBase);
};

export const getAvailableNativeApiHost = async (configuredApiHost?: string) => {
  if (!configuredApiHost || !reviewApiHostRegex.test(configuredApiHost)) {
    return configuredApiHost;
  }

  if (!nativeReviewAPIHostPromise) {
    nativeReviewAPIHostPromise = getAvailableReviewApiHost(configuredApiHost);
  }

  return nativeReviewAPIHostPromise;
};

const isReviewApiHostAvailable = async (reviewApiHost: string) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(
    () => controller.abort(),
    reviewApiAvailabilityTimeoutMs
  );

  try {
    const response = await fetch(
      `https://${reviewApiHost}${reviewApiAvailabilityPath}`,
      {
        method: "HEAD",
        signal: controller.signal,
      }
    );

    return response.ok;
  } catch (_error) {
    return false;
  } finally {
    clearTimeout(timeoutId);
  }
};

const getAvailableReviewApiHost = async (reviewApiHost: string) => {
  if (await isReviewApiHostAvailable(reviewApiHost)) {
    return reviewApiHost;
  }

  return demoApiHost;
};
